$(function () {
    var panel = $("#SuggestionPanel");
    
    //Assigns keycodes to easy to understand names
    keys = {
            ESC: 27,
            TAB: 9,
            RETURN: 13,
            UP: 38,
            DOWN: 40,
            BACK: 8,
            SPACE: 32
        };
    
    //Configures the hover intent effects
    var ConfigHover = {
        sensitivity: 3, // number = sensitivity threshold (must be 1 or higher)
        interval: 200, // number = milliseconds for onMouseOver polling interval
        timeout: 0, // number = milliseconds delay before onMouseOut
        over: showSearchMenu,
        out: hideSearchMenu
    }
    
    //When a user hovers over a search term hoverIntent is setup for that term
    $('.ui-autocomplete').hover(function()
    {
        $('.ui-autocomplete > li').hoverIntent(ConfigHover);
    });
    
    //Checks the keycode to see if anything needs to be done.
    $('#txtSearch, .ui-autocomplete').keyup(function(e) 
    {    		
    		switch (e.keyCode) 
    		{
                case keys.ESC:
                case keys.TAB:
                case keys.BACK:
                case keys.SPACE:
                case keys.RETURN:
                   	CloseSignal();
                    break;
                case keys.UP:
                case keys.DOWN:
                    keyDownUp(e);
                    break;
                default:
                    break;
          }
    });
    
    //If the window is clicked out of autocomplete closes so suggestion panel needs to close as well
    $(window).blur(function ()
    {
		panel.hide();
    });
});


//Validates search term, redundant calls and displaying the suggestion panel
function showSearchMenu(searchTerm, slowLoad)
{
	//Checks to see if the value passed in is a string or object. If it is not a string then find the strings value and assign it.
	if (!( typeof searchTerm === 'string'))
	{
		var searchTerm = $(this).children().children('.searchAutoLeft').text();
	}
	
	//Checks to see if the suggestion panel is already visible. If it is check to see if the same item has been selected.
     if($('#SuggestionPanel').is(':visible'))
     {
     		var previousSearchTerm = $('#SuggestionPanel').find('#ResultSearchTerm').text();
     		
     		//Checks to see if the search term is the same as before. If same don't open a new panel.
		if (previousSearchTerm.trim() === searchTerm.trim())
		{
			//If the autocomplete section is not visible then hide the currently showing suggestion panel
			if (!($('.ui-autocomplete').is(':visible')))
			{
				CloseSignal();
			}
			else
			{
				//Sets the position of the suggestion panel to the right of the autocomplete drop down
				SetPanelPossition();
			}
			
			//No new information is needed to be loaded so return
			return;
		}
     }
     
     //If the autocomplete section is not visible then the panel has nowhere to display so return
     if (!($('.ui-autocomplete').is(':visible')))
     {
	     return;
     }
     
     //Creates the values to reset the search panel
     var styles = {
        position: "absolute",
        top: "0px",
        left: "0px"
    };
    
    //Resets the css values for top and left to prevent bug from causing improper position
    $('#SuggestionPanel').css(styles);
    
    //Sets the position of the suggestion panel to the right of the autocomplete drop down
    SetPanelPossition();    
    
    //Trys to hide the suggestion panel before a new one is attempted to be loaded
    //This allows the slide animation to work each time when displaying a new panel
    $('#SuggestionPanel').hide('slide', { direction: 'left' }, 250);

    $.ajax({
                type: "POST",
                url: "/Header/SearchBoxSuggestions",
                dataType: "html",
                data: { searchTerm: searchTerm },
                timeout: 20000,
                async: true,
                success: function (result) 
                {
				//Fills the suggestion panel with the results
				$('#SuggestionPanel').html(result);
				//Shows the suggestion panel by sliding it from the left
				$('#SuggestionPanel').show('slide', { direction: 'left' }, 250);                	  
               }//end success
            });
            

}//end showSearchMenu

//Depricated method because panel hiding is handled elsewhere
function hideSearchMenu(elem)
{
	//Hides the suggestion panel by sliding it into the left side
	//$('#SuggestionPanel').hide('slide', { direction: 'left' }, 250);    
}//end hideSearchMenu

//Checks to see if a suggestion panel needs to be opened
function keyDownUp(e) 
{	    
	//Makes sure that the key event is inside the txtSearch textbox
	if(e.target.id === 'txtSearch')
	{
		var searchTerm = e.target.value;
			    
		//Makes sure there is a search term to use and that the autocomplete drop down is visible
		if(!(searchTerm === undefined || searchTerm === null) && $('.ui-autocomplete').is(':visible'))
		{
			showSearchMenu(searchTerm);
		}
	}
}

//Hides the suggestion panel
function CloseSignal()
{
	$("#SuggestionPanel").hide();
}

//Sets the position of the suggestion panel to the right of the autocomplete drop down
function SetPanelPossition()
{	
	$('#SuggestionPanel').position({
	my: "left top",
	at: "right top",
	of: ".ui-autocomplete",
	collision: "none"
	});
}